module.exports = __webpack_public_path__ + "static/media/right-selected.bceb4d95.svg";